{
  "hero": {
    "eyebrow": "For companies",
    "title": "Energy consumption",
    "highlight": "made profitable and sustainable",
    "subtitle": "Contract renewable energy assets and receive recurring profits and Guarantees of Origin from them."
  },
  "bento": {
    "eyebrow": "The ecosystem of solutions",
    "title": "We elevate the current renewable energy strategies of European companies",
    "subtitle": "Meeting the needs of energy management, finance and sustainability.",
    "more": "Learn more"
  },
  "cases": {
    "eyebrow": "Success stories",
    "heading": "For companies of any sector and size",
    "sub": "We elevate your energy and sustainability strategy around your company's goals.",
    "items": {
      "riduzione-prevedibile": {
        "title": "Steel company cuts its energy costs by 24.7% with DEC Energy",
        "body": "One of Europe's leading steel groups, signing a 14.4 GWh/year agreement with DEC Energy, secures predictable savings on its energy costs for the next 15 years.",
        "link": "Discover: Predictable energy cost reduction"
      },
      "conformita": {
        "title": "Packaging company secures ten-year SBTi compliance with DEC Energy",
        "body": "A packaging company subject to SBTi turns the cost of compliance into a recurring profit, securing 10 years of Guarantees of Origin production with DEC Energy.",
        "link": "Discover: Future-proof, profitable compliance"
      },
      "ebitda": {
        "title": "Paper mill owned by a Private Equity fund improves EBITDA with DEC Energy",
        "body": "A European leader in the paper industry controlled by a Private Equity fund improves its EBITDA by 320 k€, signing a ten-year agreement on a 7.2 MWp plant with DEC Energy.",
        "link": "Discover: Improve EBITDA"
      },
      "copertura-naturale": {
        "title": "Food industry company cuts energy cost volatility by 27.94% with DEC Energy",
        "body": "One of Italy's leading food producers further stabilises its energy cost by generating profits correlated with the market price of electricity.",
        "link": "Discover: Cut energy cost volatility"
      },
      "impatto": {
        "title": "BancaStato elevates its sustainability strategy with DEC Energy",
        "body": "With the DEC Energy solution, BancaStato strengthens its commitment to initiatives geared toward environmental sustainability.",
        "link": "Discover: An energy transition you can show"
      }
    }
  },
  "overview": {
    "head": "DEC Energy Contract",
    "sub": [
      "no installation",
      "no supply"
    ],
    "cowLine": "no, it's not a PPA",
    "ctaTitle": "Discover how to make your energy consumption profitable and sustainable"
  },
  "bentoSbti": {
    "time": "TIME",
    "cost": "compliance cost",
    "marketLabel": "compliance without DEC Energy",
    "zeroed": "GO cost zeroed",
    "withDec": "with DEC Energy"
  }
}
